<template src="../../components/shared/contacts/ReadOnlyTemplate.html">

</template>

<script>
    import {api} from "../../global/framework/api.js";
    import {common} from "../../global/common.js";

    export default {
        name: "ReadOnlyContactModal",
        data() {
            return {
                entityId: 0,
                entityTypeId: 0,
                contactId: 0,
                controllerName: "",
                fullName: "",
                isViewOnly: false
            };
        },
        methods: {
            async showModal({contactId, entityId, entityTypeId}) {
                this.entityId = entityId;
                this.entityTypeId = entityTypeId;
                this.contactId = contactId;
                this.controllerName = entityTypeId == common.ENTITY_TYPE.COMPANY ? "Company" : "ProviderEntity";
                //Load contact Info
                let info = await api.getDataWithTwoIds(this.controllerName, entityId, "GetContactInfo", contactId);
                this.fullName = info.fullName;
                this.isViewOnly = info.viewOnly;
                this.$refs.modalRef.open();
            },
            async makeViewOnlyContact() {
                let result = await api.post(this.controllerName, this.entityId + "/UpdateContactViewOnly/" + this.contactId, {contactId: this.contactId});
                if (result) {
                    this.$refs.modalRef.close();
                    this.$bus.$emit(this.$bus.$AcEvents.CONTACT_CHANGE, result);
                }
            }
        }
    }
</script>

<style scoped>

</style>